import HARDCODE from '../../business-const/HardCode/HardCode'

import LABEL from '../../business-const/Label/Label'

import {
    ano,
} from '../../business-components/Date/Date'

import {
    calculaJaAposentou,
} from '../../views/clientes/estudo-form/EstudoServiceCalculo'



const tabEstudoFormList = (linhaFormList, values, linhaTipoLicenca, tabClienteFormList) => {

    let tabEstudoFormListAux = []

    let cont = HARDCODE.codePoint_a
    
    if (tabClienteFormList === LABEL.tabClienteFormListPrevidenciaPrivada) {

        cont = 1

        tabEstudoFormListAux.push(
            /*String.fromCodePoint(*/cont++/*)*/ + '. ' + LABEL.previdenciaPrivada,
            /*String.fromCodePoint(*/cont++/*)*/ + '. ' + LABEL.relatorio,
        )
    }

    if (tabClienteFormList === LABEL.tabClienteFormListEstudo && !values.jsonAcessoCliente.acessoCliente) {
    
        //tabEstudoFormListAux.push(
        //    String.fromCodePoint(cont++) + '. ' + LABEL.revisaoDados,
        //    String.fromCodePoint(cont++) + '. ' + LABEL.parametros,
        //)

        //if (linhaFormList.perguntasObjetivos === HARDCODE.perguntasObjetivosObjetivos) {
            
        //    tabEstudoFormListAux.push(
        //        String.fromCodePoint(cont++) + '. ' + LABEL.objetivos,
        //    )
        //}

        //if (linhaFormList.perguntasObjetivos === HARDCODE.perguntasObjetivosPerguntas) {
            
        //    tabEstudoFormListAux.push(
        //        String.fromCodePoint(cont++) + '. ' + LABEL.perguntas,
        //    )
        //}

        if (linhaTipoLicenca.exibirSomenteConsorcio === "N") {

            tabEstudoFormListAux.push(
                String.fromCodePoint(cont++) + '. ' + LABEL.resumo,
            )
           
        //}

        //if (linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === "S") {
            
            tabEstudoFormListAux.push(
                String.fromCodePoint(cont++) + '. ' +
                    (linhaTipoLicenca.menuEstudoConferenciaDados === 'N' ? LABEL.acumulacao : LABEL.conferenciaDados),
            )
        //}

        //if (linhaTipoLicenca.exibirSomenteConsorcio === "N") {

            tabEstudoFormListAux.push(
                String.fromCodePoint(cont++) + '. ' + LABEL.protecao,
            )

             tabEstudoFormListAux.push(
                String.fromCodePoint(cont++) + '. ' + LABEL.gestaoPatrimonial,
            )

            if (
                    linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === "S" &&
                    !calculaJaAposentou(values, ano(values.dataSimulacaoEstudo))
            ) {

                tabEstudoFormListAux.push(
                    String.fromCodePoint(cont++) + '. ' + LABEL.previdenciaPrivada,
                )
            }
        }


        if (linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === "S" || linhaTipoLicenca.exibirSomenteConsorcio === "S") {

            tabEstudoFormListAux.push(
                String.fromCodePoint(cont++) + '. ' + LABEL.consorcio,
            )

            tabEstudoFormListAux.push(
                String.fromCodePoint(cont++) + '. ' + LABEL.comparacaoFinanciamentos,
            )

            if (linhaTipoLicenca.exibirSomenteConsorcio === "N") {

                tabEstudoFormListAux.push(
                    String.fromCodePoint(cont++) + '. ' + LABEL.comparacaoCenarios,
                )

                if (values.jsonComparacaoEstudos.estudos.length > 1) {

                    tabEstudoFormListAux.push(
                        String.fromCodePoint(cont++) + '. ' + LABEL.comparacaoEstudos,
                    ) 
                }
            }
        }
    }

    if (tabClienteFormList === LABEL.tabClienteFormListGestaoPatrimonial) {
    
        tabEstudoFormListAux.push(
            String.fromCodePoint(cont++) + '. ' + LABEL.gestaoPatrimonialVisao,
        )

        if (values.percMeacaoCliente) {

            tabEstudoFormListAux.push(
                String.fromCodePoint(cont++) + '. ' + LABEL.gestaoPatrimonialEstruturaFamiliar,
            )
        }

        tabEstudoFormListAux.push(
            String.fromCodePoint(cont++) + '. ' + LABEL.gestaoPatrimonialFluxoCaixa,
            String.fromCodePoint(cont++) + '. ' + LABEL.gestaoPatrimonialResumoPatrimonial,
            String.fromCodePoint(cont++) + '. ' + LABEL.gestaoPatrimonialSucessao,
            String.fromCodePoint(cont++) + '. ' + LABEL.gestaoPatrimonialEstrategiasFinanceiras,
        )

        if (linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === "S") {

            tabEstudoFormListAux.push(
                String.fromCodePoint(cont++) + '. ' + LABEL.gestaoPatrimonialProjecaoFutura,
                String.fromCodePoint(cont++) + '. ' + LABEL.gestaoPatrimonialEstrategias,
                String.fromCodePoint(cont++) + '. ' + LABEL.gestaoPatrimonialPlanejamento,
            )
        }

        //tabEstudoFormListAux.push(
        //    String.fromCodePoint(cont++) + '. ' + LABEL.relatorio,
        //)
    }

    if (tabClienteFormList === LABEL.tabClienteFormListRelatorio || values.jsonAcessoCliente.acessoCliente) {
    
        tabEstudoFormListAux.push(
        
            String.fromCodePoint(cont++) + '. ' + LABEL.relatorio,
        )
    }

    return tabEstudoFormListAux
}

export default tabEstudoFormList